export default function useConvertTimeStrToMinutes(time: string): number {
  const hour = time.split(":")[0];
  const minutes = time.split(":")[1];
  return Number(hour) * 60 + Number(minutes);
}
